import { string, object, ref, number } from 'yup';

const schema = object().shape({
  hoursDriven: string().nullable()
});

export default schema;
